import { useState, useEffect, } from "react";
import { Modal, Button, Card, } from 'antd';
import notification from '../../../services/notification';
import { XIcon, UserPlusIcon, } from "@phosphor-icons/react";
import { FormattedMessage, useIntl, } from "react-intl";
import { useForm, } from "react-hook-form";
import { UserAdd, GetCustomerUsergroups, } from '../../../services/users';
import UserFormView from './views/user.form.view';

const AddUserModal = ({
    modalIsOpen,
    modalIsOpenHandler,
    customerID,
    refreshData,
    history,
    ...props
}) => {

    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [userGroups, setUserGroups] = useState(undefined);
    const [permission, setPermission] = useState("users");
    const { handleSubmit, control } = useForm();
    const intl = useIntl();

    useEffect(() => {
        getUsergroups();
        if ("authentication" in sessionStorage) {
            const localdata = sessionStorage.getItem('authentication');
            const idToken = JSON.parse(localdata);
            if ("permission" in idToken) {
                setPermission(idToken.permission);
            }
        }
        // eslint-disable-next-line
    }, []);

    const onSubmit = (data) => {
        setButtonDisabled(true);
        const postdata = {
            "customer_id": customerID,
            "user_first_name": data.user_first_name,
            "user_last_name": data.user_last_name,
            "user_phone_number": data.user_phone_number,
            "user_email": data.user_email,
            "user_note": data.user_note,
            "user_group": data.user_group || permission,
            "user_language": data.user_language,
        };

        UserAdd(postdata, history)
            .then(response => {
                if (response.status) {
                    notification['success']({
                        message: 'User',
                        description: intl.formatMessage({ id: response.msg }),
                    });
                    // history('/customer/' + response.data.customer_id);
                    //close modal
                    modalIsOpenHandler(false);
                    refreshData();
                } else {
                    notification['error']({
                        message: 'User',
                        description: intl.formatMessage({ id: response.msg }),
                    });
                    setButtonDisabled(false);
                }
            })
            .catch(error => {
                console.error('error: ', error);
                notification['error']({
                    message: 'Account',
                    description: intl.formatMessage({ id: "UNKNOW_ERROR" }),
                });
            });
    };

    const getUsergroups = () => {
        GetCustomerUsergroups(customerID, history)
            .then(response => {
                if (response.status) {
                    var tmp = [];
                    for (let i = 0; i < response.data.user_groups.length; i++) {
                        tmp.push({
                            value: response.data.user_groups[i].ug_id,
                            label: response.data.user_groups[i].ug_name
                        });
                    }
                    // adding the build-in groups
                    tmp.push({
                        value: 'users',
                        label: 'Users (Built-in)'
                    });
                    tmp.push({
                        value: 'administrators',
                        label: 'Administrators (Built-in)'
                    });

                    setUserGroups(tmp);
                }
            })
            .catch(error => { });
    };


    return (

        <Modal
            open={modalIsOpen}
            title={<><UserPlusIcon size={16} weight="light" /> <FormattedMessage id="profile-adding-new-user" /></>}
            onCancel={() => modalIsOpenHandler(false)}
            width={750}
            footer={[
                <Button key="1" onClick={() => modalIsOpenHandler(false)}
                    icon={<XIcon size={16} />}>
                    <FormattedMessage id="cancel" />
                </Button>,
                <Button key="2"
                    className="ant-btn-success"
                    loading={buttonDisabled}
                    onClick={handleSubmit(onSubmit)}
                    icon={!buttonDisabled && (<UserPlusIcon size={16} weight="light" />)}>
                    <FormattedMessage id="add" />
                </Button>,
            ]}>

            <Card
                className="my-4"
                title={<h3><FormattedMessage id="profile-adding-new-user-details-info" /></h3>}>

                <p><FormattedMessage id="profile-adding-new-user-header" /></p>

                <UserFormView
                    formMode="add"
                    control={control}
                    history={history}
                    userGroups={userGroups}
                    {...props}
                />

            </Card>
        </Modal>
    );
};

export default AddUserModal;
